var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadTile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.334,
    y: 40,
    width: 40,
    height: 40,
    rx: 5,
    transform: "rotate(-90 .334 40)",
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.834 11.5a2 2 0 0 1 2-2h5.45a2 2 0 0 1 2 2v17a2 2 0 0 1-2 2h-5.45a2 2 0 0 1-2-2v-17z",
    fill: "#A1A5B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.385 11.5a2 2 0 0 1 2-2h5.45a2 2 0 0 1 2 2v5.45a2 2 0 0 1-2 2h-5.45a2 2 0 0 1-2-2V11.5zM21.385 23.05a2 2 0 0 1 2-2h5.45a2 2 0 0 1 2 2v5.45a2 2 0 0 1-2 2h-5.45a2 2 0 0 1-2-2v-5.45z",
    fill: "#A1A5B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadTile);
export default __webpack_public_path__ + "static/media/uploadTile.9a26d0ecb3242317adc0ec1d2ccf1b75.svg";
export { ForwardRef as ReactComponent };